import ResourceConstants from 'constants/ResourceConstants'

const CLIENT_ID_KEY = 'drift-auth-client-id'
const REDIRECT_URL_KEY = 'drift-auth-redirect-url'
const REDIRECT_URL_TIMESTAMP = 'drift-auth-redirect-set-time'

export const setRedirectInfo = (redirectUrl, clientId) => {
  redirectUrl && window.localStorage.setItem(REDIRECT_URL_KEY, redirectUrl)
  clientId && window.localStorage.setItem(CLIENT_ID_KEY, clientId)
  !!(clientId || redirectUrl) && window.localStorage.setItem(REDIRECT_URL_TIMESTAMP, Date.now())
}

export const getRedirectUrl = () => {
  const redirectUrl = window.localStorage.getItem(REDIRECT_URL_KEY)
  const redirectUrlSetTime = Number(window.localStorage.getItem(REDIRECT_URL_TIMESTAMP))

  return (!!redirectUrl && setTimeIsLessThanFiveMinAgo(redirectUrlSetTime))
    ? redirectUrl
    : ResourceConstants.DEFAULT_REDIRECT_URL
}

export const getClientId = () => {
  const clientId = window.localStorage.getItem(CLIENT_ID_KEY)
  const redirectUrlSetTime = Number(window.localStorage.getItem(REDIRECT_URL_TIMESTAMP))

  return (!!clientId && setTimeIsLessThanFiveMinAgo(redirectUrlSetTime))
    ? clientId
    : ResourceConstants.DEFAULT_CLIENT_ID
}

export const cleanUpRedirectInfo = () => {
  window.localStorage.removeItem(CLIENT_ID_KEY)
  window.localStorage.removeItem(REDIRECT_URL_KEY)
  window.localStorage.removeItem(REDIRECT_URL_TIMESTAMP)
}

const setTimeIsLessThanFiveMinAgo = (setTime) => {
  const diff = Date.now() - setTime
  const FIVE_MIN = 5 * 60 * 1000
  return diff <= FIVE_MIN
}



// WEBPACK FOOTER //
// ./src/utils/redirectUrl.js